import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/books/bookApi";
import BookCardItem from "./BookCardItem";

export default function BookCards({ filterby }) {
  const searchValue = useSelector((state) => state.books.searchValue);
  const { isSuccess, isError, isLoading, data: books } = useGetBooksQuery();
  const copyBooks = isSuccess ? [...books] : [];
  const filteredBooks =
    filterby === "featured"
      ? copyBooks.filter((book) => book.featured)
      : copyBooks;

  const filteredBooksBySearch = filteredBooks.filter((book) =>
    book.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  if (isError) return <div>Something went wrong</div>;
  if (isLoading) return <div>Loading...</div>;

  return (
    <div class="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {filteredBooksBySearch?.map((book) => (
        <BookCardItem key={book.id} book={book} />
      ))}
    </div>
  );
}
